import { secureGet } from "../../Config/ApiConfig";

export const getPayment = async (payment_id) => {
    const { data } = await secureGet(`/payments/${payment_id}`);
    return data;
};